import { useState } from 'react';

interface SetFieldValueProps {
  name: string;
  value: any;
}

function useFields(fieldsDefault: any) {
  // Inicia en false
  const fieldsErrorDefault: any = {};
  Object.entries(fieldsDefault).forEach((field) => {
    fieldsErrorDefault[field[0]] = false;
  });

  const [fields, setFields] = useState(fieldsDefault);
  const [errors, setErrors] = useState(fieldsErrorDefault);

  const setFieldValue = (props: SetFieldValueProps | SetFieldValueProps[]) => {
    if (props instanceof Array) {
      const newValues: any = {};
      props.forEach((t: SetFieldValueProps) => {
        newValues[t.name] = t.value;
      });
      setFields({
        ...fields,
        ...newValues
      });
    } else {
      const { name, value } = props;
      setFields({
        ...fields,
        [name]: value
      });
    }
  };

  const setFieldError = ({ name, value }: { name: string; value: boolean }) => {
    setErrors({
      ...errors,
      [name]: value
    });
  };

  const atLeastOneFieldIsFull = (() => {
    const existField = [...Object.values(fields)].find((field) =>
      Boolean(field)
    );
    return Boolean(existField);
  })();

  const atLeastOneFieldIsFullWithDataRemove = (fieldsRemove: any) => {
    const existField = [...Object.values(fieldsRemove)].find((field) =>
      Boolean(field)
    );
    return Boolean(existField);
  };

  // Si no hay errores y si al menos 1 campo está lleno
  const formIsValid = (() => {
    const existsError = [...Object.values(errors)].reduce(
      (prev, current) => prev || current,
      false
    );
    return !existsError && atLeastOneFieldIsFull;
  })();

  const formIsValidWithDataRemove = (fieldsRemove: any) => {
    const duplicateObject: any = { ...errors };
    const duplicateObjectFields: any = { ...fields };

    Object.keys(duplicateObjectFields).forEach((e: any) => {
      Object.keys(fieldsRemove).forEach((i: any) => {
        if (i === e) delete duplicateObjectFields[e];
      });
    });

    Object.keys(duplicateObject).forEach((e: any) => {
      Object.keys(fieldsRemove).forEach((i: any) => {
        if (i === e) delete duplicateObject[e];
      });
    });

    const existsError = [...Object.values(duplicateObject)].reduce(
      (prev, current) => prev || current,
      false
    );

    return (
      !existsError && atLeastOneFieldIsFullWithDataRemove(duplicateObjectFields)
    );
  };

  // Valida que TODOS los campos esten llenos, ajustar luego si hay opcionales
  const formIsComplete = (() => {
    const existsEmptyField = [...Object.values(fields)].find(
      (field) => Boolean(field) === false
    );
    return typeof existsEmptyField === 'undefined';
  })();

  const formIsIncomplete = (fieldsRemove: any) => {
    const duplicateObject: any = { ...fields };
    Object.keys(duplicateObject).forEach((e: any) => {
      Object.keys(fieldsRemove).forEach((i: any) => {
        if (i === e) delete duplicateObject[e];
      });
    });
    const existsEmptyField = [...Object.values(duplicateObject)].find(
      (field) => Boolean(field) === false
    );
    return typeof existsEmptyField === 'undefined';
  };

  const formIsEmptyIncomplete = (fieldsRemove: any) => {
    const duplicateObject: any = { ...fields };
    Object.keys(duplicateObject).forEach((e: any) => {
      Object.keys(fieldsRemove).forEach((i: any) => {
        if (i === e) delete duplicateObject[e];
      });
    });
    const existsEmptyField = [...Object.values(duplicateObject)].find(
      (field) => Boolean(field) === true
    );
    return typeof existsEmptyField === 'undefined';
  };

  // Valida que TODOS los campos esten vacios, ajustar luego si hay opcionales
  const formIsEmpty = (() => {
    const existsEmptyField = [...Object.values(fields)].find(
      (field) => Boolean(field) === true
    );
    return typeof existsEmptyField === 'undefined';
  })();

  const formIsEditing = false;

  return {
    fields,
    errors,
    formIsValid,
    formIsEditing,
    setFieldValue,
    setFieldError,
    formIsComplete,
    formIsEmpty,
    formIsIncomplete,
    formIsEmptyIncomplete,
    formIsValidWithDataRemove
  };
}

export default useFields;
